import gql from "graphql-tag";

const QUERY_ME = gql`
  query {
    me {
      id
      username
    }
  }
`;
export default QUERY_ME;
